module.exports = __webpack_public_path__ + "static/media/tmall-guide-background.8758f1ec.png";